@use '@/styles/tokens' as *;

.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: var(--space-12) var(--space-6);
  text-align: center;
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  margin-bottom: var(--space-2);
  border-radius: var(--radius-pill);
  background: var(--surface-muted);
  color: var(--text-tertiary);
}

/* Self-contained illustration image — no circle behind it. */
.iconBare {
  width: auto;
  height: auto;
  background: none;
  border-radius: 0;
}

.iconBare img {
  display: block;
  width: 72px;
  height: 72px;
  object-fit: contain;
}

.title {
  margin: 0;
  font-family: #{$font-family-heading};
  font-size: 20px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.description {
  max-width: 360px;
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
}

.action {
  margin-top: var(--space-3);
}
